export default "__VITE_ASSET__DXQqYdUd__"